import React from 'react';

const CloudManagement = ({ language = 'en' }) => {
  const content = {
    en: {
      title: 'Cloud & Central Management',
      subtitle: 'EV Central Management System',
      description: 'As the neural center of the charging network, the EV Central Management System is the core technological engine guaranteeing the stable operation of the entire charging ecosystem. Developed based on a cloud architecture, it features real-time monitoring, remote control, and dynamic Load Balancing for charging devices across all scenarios. Through the central control panel, management teams can monitor the status of every charging pile anytime anywhere, intelligently allocate power resources to prevent overload, and optimize operational strategies through in-depth data analysis. More than just a device management tool, this system serves as a data-driven decision-making center for property owners to achieve commercial operation and asset appreciation.'
    },
    zh: {
      title: '雲端及中央管理系統',
      subtitle: '電動車充電中央管理系統',
      description: '作為充電網絡的神經中樞，電動車充電中央管理系統是保障整個充電生態穩定運行的核心技術引擎。基於雲端架構開發，系統實現了對全場景充電設備的實時監控、遠程控制與動態負載平衡（Load Balancing）。管理團隊可透過中央控制台，隨時隨地監控每一台充電樁的運行狀態，智能調配電力資源以防範過載，並通過深度數據分析優化運營策略。這套系統不僅是設備管控工具，更是物業方實現商業化運營與資產增值的數據決策中心。'
    }
  };

  const currentContent = content[language] || content.en;

  return (
    <section id="ev-cloud-management" className="service__section pt-120 pb-120">
      <div className="container">
        <div className="project__head text-center mb-60">
          <span className="common__sub aos-init aos-animate" data-aos="fade-down" data-aos-duration="1000">
            {currentContent.title}
          </span>
          <h2 className="fw-500 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" style={{ color: '#c9f31d' }}>
            {currentContent.subtitle}
          </h2>
        </div>

        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          {/* Hero Image */}
          <div style={{ position: 'relative', zIndex: 1, borderRadius: '12px', overflow: 'hidden', marginBottom: '2rem' }}>
            <img
              src="/assets/photos/cloud-management.jpeg"
              alt="Cloud & Central Management System"
              style={{ width: '100%', height: 'auto', display: 'block', borderRadius: '12px' }}
            />
          </div>
          <div 
            className="aos-init aos-animate"
            data-aos="fade-up"
            data-aos-duration="1000"
            style={{
              background: 'rgba(255, 255, 255, 0.03)',
              padding: '2.5rem',
              borderRadius: '12px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'all 0.3s ease'
            }}
          >
            <p className="pra fz-18" style={{
              lineHeight: '1.9',
              color: '#e0e0e0',
              textAlign: 'justify',
              margin: 0
            }}>
              {currentContent.description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CloudManagement;
